import { QueryClient } from '@tanstack/react-query';
export var DEFAULT_CACHE_TIME = 1000 * 60 * 3;
export var QUERY_CLIENT = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_CACHE_TIME,
            cacheTime: DEFAULT_CACHE_TIME,
            retry: 2,
        },
    },
});
